export const GET_GETTING_STARTED_STEPS = 'GET_GETTING_STARTED_STEPS';
export const GET_TRIAL_DAYS_REMAINING = 'GET_TRIAL_DAYS_REMAINING';
